/**
 * This is the app routes configuration.
 * Only configure routes in this file.
 * @memberOf app Module
 * @namespace app Routes
 */
import twofaAppTemplate from './2fa.app.html';


/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf app Module.memword Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	/* Create the app state and assign the template and controller. */
	$stateProvider
		.state('login.2fa.app', {
			url: '/register/app',
			template: twofaAppTemplate,
			controller: 'twofaAppController',
			controllerAs: 'vm'
		});
}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/app/2fa.app.route.js